<template>
  <div class="text-center">
    <i class="iconetitulo" :class="classeAwesome" aria-hidden="true"></i>
    <h2 id="titulo">{{ nome }}</h2>

    <div id="linhadivisoria"></div>
  </div>
</template>

<script>
export default {
  props: {
    classeAwesome: {
      // AQUI VAI A CLASSSE FORNECIDA PELA FONT AWESOME
      required: true,
      type: String
    },
    nome: {
      type: String
    }
  }
};
</script>

<style>
.iconetitulo {
  color: #056f94;
  font-size: 2rem;
}

#titulo {
  display: inline-block;
  margin-left: 20px;
  color: #056f94;
}

#linhadivisoria {
  margin-top: 2px;
  border-bottom: 2px solid #056f94;
  margin-bottom: 30px;
}
</style>
